import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import { FormControl } from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';
import utils from 'src/utils/utils';
import ValidityAdornment from './fields/ValidityAdornment';

const SchedulerField = ({ classes, period, onChange, isValid }) => {
  const { t } = useTranslation();
  return (
    <FormControl className={classes.container}>
      <ValidityAdornment
        validity={{
          isValid,
          messages: [t('smartmessaging.smartjourney.invalidPeriod')],
        }}
        position="start"
      />
      <DatePicker
        closeOnSelect
        className={classes.textField}
        slotProps={{
          textField: {
            required: true,
          },
          actionBar: {
            actions: [],
          },
        }}
        format="dd/MM/yyyy"
        label={t('smartmessaging.campaignEditor.scheduler.beginDate')}
        value={(utils.isValidDate(new Date(period.start)) && new Date(period.start)) || null}
        onChange={date => {
          onChange('start', date);
        }}
      />
      <DatePicker
        closeOnSelect
        className={classes.textField}
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
        }}
        format="dd/MM/yyyy"
        label={t('smartmessaging.campaignEditor.scheduler.endDate')}
        value={
          (period.end && utils.isValidDate(new Date(period.end)) && new Date(period.end)) || null
        }
        onChange={date => {
          if (!date || utils.isValidDate(date)) onChange('end', date);
        }}
      />
      <TimePicker
        ampm={false}
        format="HH:mm"
        label={t('smartmessaging.campaignEditor.scheduler.time')}
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
          textField: {
            required: true,
          },
        }}
        value={(period.time && utils.getNewDateWithTime(period.time)) || null}
        onChange={time => {
          onChange('time', time.toLocaleTimeString().slice(0, 5));
        }}
        className={classes.textField}
      />
    </FormControl>
  );
};

SchedulerField.propTypes = {
  classes: PropTypes.object.isRequired,
  period: PropTypes.object.isRequired,
  isValid: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(SchedulerField, theme => ({
  container: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
  },
  textField: {
    flex: 1,
    fontSize: '0.975rem',
    marginLeft: `${theme.spacing(1)}!important`,
    marginRight: `${theme.spacing(1)}!important`,
  },
}));
